import { Box, Typography, Divider } from "@mui/material";
import Grid from '@mui/material/Grid2';
import contact_img from '~/assets/images/contact_img.png';
const Contact = () => {
    return (
        <Box sx={{ mt: 2, pb: 6 }}>
            <Box
                sx={{
                    minHeight: 200,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    fontSize: 26,
                    fontWeight: 'bold',
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${contact_img})`,
                    backgroundPosition: 'center'

                }}>
                LIÊN HỆ VỚI CHÚNG TÔI
            </Box>

            <Box sx={{ maxWidth: 'lg', marginInline: 'auto', mt: 6, p: 2 }}>
                <Grid container spacing={4} >
                    <Grid size={{ md: 6, xs: 12 }}>
                        <Typography variant='h6' sx={{ fontWeight: "bold", color: "var(--primary)", textAlign: "center" }}>
                            ĐỊA CHỈ LIÊN HỆ
                        </Typography>
                        <Divider sx={{ marginBlock: 4 }} />
                        <Typography sx={{ fontWeight: "bold", color: "var(--primary)" }}>
                            TRUNG TÂM NGOẠI NGỮ VÀ TIN HỌC
                        </Typography>
                        <Typography sx={{ mt: 2 }} >
                            Phòng giao dịch Ki ốt 1-2, số 783 Phạm Hữu Lầu, Phường 6, TP.Cao Lãnh, Đồng Tháp
                        </Typography>
                        <Box sx={{ mt: 2 }}>
                            Phone: <Typography sx={{ fontWeight: 'bold', display: 'inline-block', color: "var(--primary)" }}>02773 881.715</Typography>
                        </Box>
                        <Box sx={{ mt: 2 }}>
                            Email: <Typography sx={{ fontWeight: 'bold', display: 'inline-block', color: "var(--primary)" }}>ttnnth@dthu.edu.vn</Typography>
                        </Box>
                    </Grid>
                    <Grid size={{ md: 6, xs: 12 }}>
                        <Typography variant='h6' sx={{ fontWeight: "bold", color: "var(--primary)", textAlign: "center" }}>
                            BẢN ĐỒ
                        </Typography>
                        <Divider sx={{ marginBlock: 4 }} />
                        <Box sx={{ borderRadius: 4, overflow: "hidden", height: 350, border: "1px solid #ccc" }}>
                            <iframe
                                title="Bando"
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1962.0116499332487!2d105.643818!3d10.419724000000016!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x310a64d83b2792df%3A0x17bca5e601420f5a!2zVHLGsOG7nW5nIMSQ4bqhaSBo4buNYyDEkOG7k25nIFRow6Fw!5e0!3m2!1svi!2sus!4v1740969160750!5m2!1svi!2sus"
                                loading="lazy"
                                style={{ width: "100%", height: "100%", border: 0 }}
                            />
                        </Box>

                    </Grid>
                </Grid>
            </Box>
        </Box>

    )
}

export default Contact;